module.exports = __webpack_public_path__ + "static/img/13.6c0748d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/13.png
// module id = OnSs
// module chunks = 0